/**
 * Log de diagnóstico del pickeo por escaneo — backend real.
 *
 * `POST /api/pickeo-log/lectura`: por cada lectura del modal "Pickear" se
 * manda el texto crudo, el resultado, la traza de teclas y el entorno del
 * navegador. Sirve para ver qué transmite cada lector en cada PC del
 * laboratorio (separador GS, distribución de teclado). El back completa
 * usuario y user-agent. Se dispara fire-and-forget desde `usePickeoLotes`.
 */

import { apiFetch } from '@/api/http';

/** Un evento de teclado de la traza. Nombres cortos: viajan ~100 por lectura. */
export interface TeclaLectura {
  /** KeyboardEvent.key */
  k: string;
  /** KeyboardEvent.code */
  c: string;
  /** altKey */
  a?: boolean;
  /** ctrlKey */
  ct?: boolean;
  /** shiftKey */
  s?: boolean;
  /** metaKey */
  m?: boolean;
  /** true si es un keyup (solo se anota para Alt). */
  up?: boolean;
  /** ms desde la tecla anterior (0 en la primera). */
  dt: number;
}

export interface EntornoLector {
  plataforma: string | null;
  idioma: string | null;
  /** Muestra de `navigator.keyboard.getLayoutMap()`: code físico → carácter del host. */
  layout: Record<string, string> | null;
}

export interface RegistrarLecturaInput {
  referencia: string | null;
  texto: string;
  /** `TipoResultadoPickeo` (pickeada, ajena, …). */
  resultado: string;
  gtin: string | null;
  lote: string | null;
  serie: string | null;
  duracionMs: number | null;
  teclas: TeclaLectura[] | null;
  entorno: EntornoLector | null;
}

export interface RegistrarLecturaResponse {
  ok: boolean;
  id: number;
}

export function registrarLectura(input: RegistrarLecturaInput): Promise<RegistrarLecturaResponse> {
  return apiFetch<RegistrarLecturaResponse>('/pickeo-log/lectura', {
    method: 'POST',
    body: input,
    auth: true,
  });
}
